var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar56 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.5 8C28.6903 8 28.8642 8.10794 28.9484 8.27843L35.0121 20.5525L48.5719 22.5206C48.7603 22.5479 48.9167 22.6797 48.9755 22.8605C49.0344 23.0413 48.9853 23.2398 48.849 23.3725L39.0373 32.9257L41.3538 46.4161C41.386 46.6035 41.3089 46.7928 41.1549 46.9046C41.0009 47.0163 40.7968 47.0311 40.6284 46.9426L28.5 40.5738L16.3717 46.9426C16.2032 47.0311 15.9991 47.0163 15.8451 46.9046C15.6911 46.7928 15.614 46.6035 15.6462 46.4161L17.9628 32.9257L8.15102 23.3725C8.01473 23.2398 7.96567 23.0413 8.02448 22.8605C8.0833 22.6797 8.23977 22.5479 8.42812 22.5206L21.988 20.5525L28.0516 8.27843C28.1359 8.10794 28.3097 8 28.5 8ZM28.5 9.62809L22.7684 21.23C22.6956 21.3774 22.5548 21.4796 22.3919 21.5033L9.57454 23.3636L18.849 32.3937C18.9669 32.5084 19.0206 32.6738 18.9928 32.8358L16.8031 45.5875L28.2674 39.5674C28.413 39.4909 28.587 39.4909 28.7327 39.5674L40.1969 45.5875L38.0072 32.8358C37.9794 32.6738 38.0332 32.5084 38.151 32.3937L47.4255 23.3636L34.6081 21.5033C34.4453 21.4796 34.3045 21.3774 34.2316 21.23L28.5 9.62809Z",
  fill: "currentColor"
})));
export default SvgStar56;